/* eslint jsx-a11y/anchor-is-valid: 0 */

import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import AuthService from '../../state/auth.service';
import Logo from '../logo';
import { history } from '../../state/store';
import AppsNavigation from './appsNavigation';

class AuthenticatedNavbar extends Component {
    constructor(props, context) {
        super(props, context);

        this.signOut = this.signOut.bind(this);
    }

    signOut() {
        AuthService.signOut();
        history.push('/account/signin');
    }

    render() {
        const user = AuthService.getUser();
        let linkName = 'Account';
        if (user.name && user.name.length > 0) {
            linkName = user.name;
        }

        return (
            <header className="Navbar">
                <div className="Navbar__logo">
                    <Link to="/">
                        <Logo />
                    </Link>
                </div>
                <AppsNavigation />
                <nav>
                    <ul>
                        <li>
                            <Link to="/user/account">{linkName}</Link>
                        </li>
                        <li>
                            <a onClick={this.signOut}>Logout</a>
                        </li>
                    </ul>
                </nav>
            </header>
        );
    }
}

export default AuthenticatedNavbar;
